module.exports = __webpack_public_path__ + "img/green.36117248.png";